import * as React from 'react';
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

const AppDialog = ({
    open,
    onClose,
    content,
    title,
    firstBtnContent,
    secondBtnContent,
    firstBtnClickHandler,
    secondBtnClickHandler,
    options = {
        keepMounted: false,
        btnLoading: false,
    }
}) => {
    return (
        <Dialog
            open={open}
            keepMounted={options.keepMounted}
            onClose={onClose}
            sx={styles.mainDialog} >
            <Grid p={4}>
                <DialogTitle sx={styles.confirmTitleText}>
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" sx={styles.confirmContentText}>
                        {content}
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={styles.confirmBtnDialog}>
                    <Button sx={[styles.btnText, styles.noBtnText]}
                        onClick={firstBtnClickHandler}>
                        {firstBtnContent}
                    </Button>
                    <Button sx={[styles.btnText, styles.yesBtnText]}
                        disabled={options.btnLoading}
                        onClick={secondBtnClickHandler}>
                        {secondBtnContent}
                    </Button>
                </DialogActions>
            </Grid>
        </Dialog >
    );
};

export default AppDialog;

const styles = {
    mainDialog: {
        '& .MuiDialog-paper': {
            borderRadius: 3,
            xs: {
                width: 'calc(100% - 2rem)',
            },
            sm: {
                width: '36rem'
            },
        },
    },
    confirmTitleText: {
        fontFamily: 'GilroyBold',
        textAlign: 'center',
    },
    confirmContentText: {
        fontFamily: 'GilroyMedium',
        textAlign: 'center'
    },
    confirmBtnDialog: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around'
    },
    btnText: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textTransform: 'capitalize',
        fontFamily: "GilroySemiBold",
        height: "2.5rem",
        padding: "0 18px",
        fontSize: "14px",
        cursor: "pointer",
        border: "2px solid #000000",
        borderRadius: "8px",
        flex: 1
    },
    noBtnText: {
        color: '#000000',
        '&:hover': {
            backgroundColor: '#ffffff !important',
        },
    },
    yesBtnText: {
        backgroundColor: '#000000',
        color: '#ffffff !important',
        borderRadius: 2,
        px: 2,
        '&:hover': {
            color: '#ffffff !important',
            backgroundColor: '#000000 !important',
        },
        '&:disabled': {
            opacity: 0.5
        }
    }
}
